import * as React from 'react';
import type { sendNewSignupLink } from 'state/actions/complete-signup';
import { CompleteSignupExpiredTokenScreenStateless } from '../complete-signup-expired-token-screen-stateless';

interface CompleteSignupExpiredTokenScreenProps {
    email: string;
    portalId?: number;
    isNewSignupLinkBeingSent: boolean;
    sendNewSignupLinkAction: typeof sendNewSignupLink;
}

export class CompleteSignupExpiredTokenScreen extends React.Component<CompleteSignupExpiredTokenScreenProps> {
    sendNewSignupLink = () => {
        const { email, portalId, sendNewSignupLinkAction } = this.props;
        sendNewSignupLinkAction(email, portalId);
    };

    render() {
        return (
            <CompleteSignupExpiredTokenScreenStateless
                isNewSignupLinkBeingSent={this.props.isNewSignupLinkBeingSent}
                onSendNewLinkClicked={this.sendNewSignupLink}
            />
        );
    }
}

export default CompleteSignupExpiredTokenScreen;
